

import VM from './product/vm';
import YunDisk from './product/yundisk';
import RDS from './product/rds';
import CommonBuy from './product/commonBuy';

let products = [VM, RDS,YunDisk];


function getProduct (goods) {

  let code = goods.commodityCode;
  
  //找到匹配的产品
  let Product = products.find((item) => item.prototype.match(code));


  //匹配不到单产品，则匹配CommonBuy，当为自定义商品的不实例化产品
  if(Product == null && goods.accessories && goods.accessories.specsType != 'custom' && goods.accessories.commodity) {
    Product = CommonBuy;
  }
  return Product ? new Product(goods) : null;
}

export {getProduct};


// WEBPACK FOOTER //
// ./lib/services/index.js